module.exports = __webpack_public_path__ + "img/background-card.a304353.svg";